module.exports = __webpack_public_path__ + "img/pw.20a1d020.svg";